<div class="w-full h-full flex flex-row overflow-hidden relative">
  @if (isNavbarShown$ | async) {
    <app-navbar-host class="h-full"></app-navbar-host>
  }

  <div class="flex-1 w-full min-h-full bg-navy-30 overflow-hidden">
    <app-global-loader></app-global-loader>
    <router-outlet></router-outlet>
  </div>

  @if (isRealClientOverlayDisplyed) {
    <div class="real-client-overlay">
      <span class="real-client-label">{{ 'realClient' | translate }}</span>
      <span class="real-client-label">{{ 'realClient' | translate }}</span>
      <span class="real-client-label">{{ 'realClient' | translate }}</span>
    </div>
  }

  @if (isAuditorSimulationMode) {
    <div data-test-id="auditor-simulation-overlay" class="auditor-simulation-overlay">
      <span class="auditor-simulation-label">{{ 'auditorSimulationMode' | translate }}</span>
      <span class="auditor-simulation-label">{{ 'auditorSimulationMode' | translate }}</span>
      <span class="auditor-simulation-label">{{ 'auditorSimulationMode' | translate }}</span>
    </div>
  }
</div>
